import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

const BottomNavBar = () => {
  return (
      <AppBar
        position="fixed"
        style={{ top: "auto", bottom: 0, background: "#52B44B" }}
      >
        <Typography variant="body2" color="textSecondary" align="center">
          {"Copyright © "}
          <Link
            color="inherit"
            href="https://www.safaricom.co.ke/"
            target="_blank"
            rel="noopener"
          >
            {process.env.REACT_APP_COMPANY_NAME}
          </Link>{" "}
          {new Date().getFullYear()}
          {"."} <code>v{global.appVersion}</code>
        </Typography>
      </AppBar>
  );
};

export default BottomNavBar;
